export const API_URL = 'https://monitoring-api.arkeon.pro';
export const REFRESH_FREQUENCY = 5;